import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Star, TrendingUp } from 'lucide-react';
import { TranslatedText } from '@/components/TranslatedText';
import { TestimonialsColumn } from '@/components/ui/testimonials-columns-1';

const testimonials = [
  {
    quote: "Went from zero to consistent revenue in just 2 weeks. The faceless content module was a game-changer. I now manage four 100k+ followers AI Influencers Models in TikTok, Instagram and more. I make more online than my job, without showing my face.",
    name: "Sarah M.",
    highlight: "2 weeks to income",
    avatar: "S",
  },
  {
    quote: "Finally found a way to build online without sacrificing my privacy. The AI automation saves me hours every single day.",
    name: "Jason K.",
    highlight: "Hours saved daily",
    avatar: "J",
  },
  {
    quote: "The newsletter module helped me build an engaged audience. Best investment I've made. I'm happier than ever with my results.",
    name: "Michael R.",
    highlight: "Engaged audience",
    avatar: "M",
  },
  {
    quote: "As an introvert, showing my face was never an option. This gave me a path I never knew existed. I'm managing 21 e-commerce shops across 20 countries. My first shop got profitable in 2 weeks.",
    name: "Emily T.",
    highlight: "21 stores, 20 countries",
    avatar: "E",
  },
];

const columnTestimonials = [
  { text: "I joined without expecting much, but the structure surprised me. Everything is step-by-step and actually doable. First online income after 3 weeks.", name: "Jake M.", role: "Texas", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face" },
  { text: "The community is the real value. Whenever I got stuck someone already solved the same problem. Saved me months of frustration.", name: "Amanda R.", role: "California", image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face" },
  { text: "I've bought courses before… this is the first one where support actually answers. That alone makes the difference.", name: "Daniel P.", role: "Florida", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face" },
  { text: "Simple, practical and straight to the point. No fluff, just implementation.", name: "Chris L.", role: "New York", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face" },
  { text: "I work full time and still managed to start. The lessons are short and easy to follow.", name: "Olivia K.", role: "Arizona", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face" },
  { text: "They don't just teach — they show real workflows. Helped me understand how online business actually works.", name: "Marcus B.", role: "Georgia", image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face" },
  { text: "The networking inside the academy opened doors I didn't even know existed.", name: "Tyler S.", role: "Ohio", image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop&crop=face" },
  { text: "Biggest benefit: avoiding beginner mistakes. That alone paid for the program.", name: "Ryan D.", role: "Nevada", image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=100&h=100&fit=crop&crop=face" },
  { text: "Very beginner friendly. I had zero experience and never felt lost.", name: "Lauren W.", role: "Illinois", image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face" },
  { text: "Finally something actionable. Implemented day one.", name: "Ethan C.", role: "Colorado", image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=100&h=100&fit=crop&crop=face" },
  { text: "What I liked most is the continuous updates. They actually improve the training instead of leaving it outdated.", name: "Kevin H.", role: "North Carolina", image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face" },
  { text: "Interactive lessons keep you focused. Doesn't feel like watching boring lectures.", name: "Brittany T.", role: "Washington", image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&h=100&fit=crop&crop=face" },
  { text: "The accountability aspect pushed me to stay consistent. That's why it worked.", name: "Noah G.", role: "Michigan", image: "https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=100&h=100&fit=crop&crop=face" },
  { text: "You get access to people already making money, which changes your mindset fast.", name: "Anthony V.", role: "New Jersey", image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=100&h=100&fit=crop&crop=face" },
  { text: "Clear roadmap from beginner to advanced. No guessing what to do next.", name: "Samantha E.", role: "Oregon", image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop&crop=face" },
  { text: "Support answered me at 2am… didn't expect that.", name: "Brandon F.", role: "Pennsylvania", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=100&h=100&fit=crop&crop=face" },
  { text: "Perfect if you overthink starting. They simplify everything.", name: "Megan A.", role: "Utah", image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=100&h=100&fit=crop&crop=face" },
  { text: "Very practical education compared to traditional courses.", name: "Jonathan R.", role: "Virginia", image: "https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=100&h=100&fit=crop&crop=face" },
  { text: "Small improvements weekly make a huge difference over time.", name: "Ashley D.", role: "Minnesota", image: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face" },
  { text: "The environment keeps you motivated. Everyone is building something.", name: "Nathan P.", role: "Tennessee", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face&q=80&sat=-100" },
  { text: "Legit community. Real people, real results.", name: "Carlos M.", role: "California", image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face&q=80&sat=-100" },
  { text: "Started as a beginner, now consistent income.", name: "Trevor K.", role: "Texas", image: "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=100&h=100&fit=crop&crop=face" },
  { text: "Easy to understand, even easier to apply.", name: "Emily J.", role: "Massachusetts", image: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=100&h=100&fit=crop&crop=face" },
  { text: "Worth it for the mentorship alone.", name: "Jason W.", role: "Indiana", image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop&crop=face&q=80&sat=-100" },
  { text: "You're never stuck because help is always there.", name: "Victoria S.", role: "Maryland", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face" },
  { text: "Saved me months of trial and error.", name: "Adam L.", role: "Wisconsin", image: "https://images.unsplash.com/photo-1530268729831-4b0b9e170218?w=100&h=100&fit=crop&crop=face" },
  { text: "Clear explanations, no confusion.", name: "Rachel N.", role: "Missouri", image: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=100&h=100&fit=crop&crop=face" },
  { text: "You just follow the system and it works.", name: "Dylan B.", role: "South Carolina", image: "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?w=100&h=100&fit=crop&crop=face" },
  { text: "Best decision I made this year.", name: "Nicole H.", role: "Colorado", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=face" },
  { text: "If you actually apply it, you'll see progress.", name: "Michael T.", role: "California", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face&q=80&sat=-100" },
];

const firstColumn = columnTestimonials.filter((_, i) => i % 3 === 0);
const secondColumn = columnTestimonials.filter((_, i) => i % 3 === 1);
const thirdColumn = columnTestimonials.filter((_, i) => i % 3 === 2);

const stats = [
  { value: "1,200+", label: "Members" },
  { value: "92%", label: "Satisfaction" },
  { value: "4.9/5", label: "Rating" },
];

export const LightTestimonialsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} id="testimonials" className="py-12 sm:py-20 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground mb-3">
            <TranslatedText>What Members Are Saying</TranslatedText>
          </h2>
          <p className="text-base text-muted-foreground">
            <TranslatedText>Real results from real people building faceless businesses.</TranslatedText>
          </p>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex justify-center gap-6 mb-10"
        >
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-2xl font-bold text-primary">{stat.value}</p>
              <p className="text-xs text-muted-foreground">
                <TranslatedText>{stat.label}</TranslatedText>
              </p>
            </div>
          ))}
        </motion.div>

        {/* Scrolling Testimonial Columns */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex justify-center gap-4 max-h-[500px] overflow-hidden [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]"
        >
          <TestimonialsColumn testimonials={firstColumn} duration={45} className="hidden sm:block" />
          <TestimonialsColumn testimonials={secondColumn} duration={55} />
          <TestimonialsColumn testimonials={thirdColumn} duration={50} className="hidden lg:block" />
        </motion.div>

        {/* Disclaimer */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center text-xs text-muted-foreground mt-6 px-4"
        >
          <TranslatedText>* Results vary based on effort and market conditions.</TranslatedText>
        </motion.p>
      </div>
    </section>
  );
};

export default LightTestimonialsSection;
